import Vue from 'vue';
import App from './App.vue';
import { Dialog, Select, Option } from 'element-ui';
import './assets/css/common.css';
import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false;
Vue.use(Dialog);
Vue.use(Select);
Vue.use(Option);
// 挂载 process 对象到全局变量中
window.process = require('process/browser');

new Vue({
  render: (h) => h(App),
}).$mount('#app');
